import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight } from "lucide-react";
import LeadDialog from "@/components/LeadDialog";
import { ARTICLES } from "@/data/content";

export default function BlogArticle() {
  const { slug } = useParams();
  const article = ARTICLES.find((a) => a.slug === slug);

  useEffect(() => {
    document.title = article ? `${article.title} · PRIMEC2E` : "Article · PRIMEC2E";
  }, [article]);

  if (!article) {
    return (
      <div className="bg-white">
        <Header />
        <main className="max-w-3xl mx-auto px-6 pt-40 pb-32 text-center">
          <h1 className="font-display text-3xl font-bold text-midnight">Article introuvable</h1>
          <Link to="/blog"><Button className="mt-8 rounded-none bg-emerald hover:bg-emerald-600 text-white">Retour au blog</Button></Link>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-white">
      <Header />
      <main>
        <article>
          <div className="relative h-[420px]">
            <img src={article.image} alt={article.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-midnight/70" />
            <div className="absolute inset-0 flex items-end">
              <div className="max-w-4xl mx-auto px-6 lg:px-8 pb-12 w-full">
                <span className="bg-emerald text-white px-3 py-1 text-xs font-medium uppercase tracking-wider">{article.category}</span>
                <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-white mt-4 max-w-3xl">{article.title}</h1>
                <p className="text-slate-300 mt-3">{article.date}</p>
              </div>
            </div>
          </div>

          <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
            <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-emerald mb-8">
              <ArrowLeft className="h-4 w-4" /> Retour aux actualités
            </Link>
            <div className="space-y-6">
              {article.content.map((p, i) => (
                <p key={i} className="text-lg text-slate-700 font-light leading-relaxed">{p}</p>
              ))}
            </div>

            <div className="mt-14 bg-slate-100 p-8 border-l-4 border-emerald">
              <h3 className="font-display text-xl font-bold text-midnight">Un projet de performance énergétique ?</h3>
              <p className="text-slate-600 mt-2 font-light">Demandez un audit gratuit et découvrez votre potentiel d'économies et de financement CEE.</p>
              <LeadDialog leadType="audit">
                <Button className="mt-6 rounded-none bg-emerald hover:bg-emerald-600 text-white px-8 py-6 group" data-testid="article-cta">
                  Demander un audit <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </LeadDialog>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
